import React from 'react'
import NotificationBadge from '@bt-react/components/NotificationBadge'
import Icon, { IconType } from '@bt-react/components/Icon'
import classnames from 'classnames'
import componentStyles from './MediaMenuItem.module.scss'
import styles from '@bt-react/styles'
import TooltipWrapper from '@bt-react/components/TooltipWrapper'
import { MediaMenuItemProps, MediaMenuItemState } from './types'
import audit from '../../../lib/audit'

class MediaMenuItem extends React.Component<MediaMenuItemProps, MediaMenuItemState> {

  constructor (props) {

    super(props)
    this.state = {
      tooltipRef: React.createRef(),
      toggledTip: false
    }

  }

  toggleTip = () => {

    this.setState({
      toggledTip: !this.state.toggledTip
    })

  }

  notifications = () => {

    return (
      <div className={componentStyles['notifications']} >
        {!!this.props.notifications && <NotificationBadge isActive={true} notifications={this.props.notifications} />}
      </div>)

  }

  handleClick = () => {

    if (this.props.mediaType && this.props.BTID) {

      audit.addEntry('PresenterService', 'MediaTypeSelected', `${this.props.mediaType} selected`, 'info', this.props.BTID)

    }

    this.props.onClick()

  }

  render () {

    const mediaMenuItemClasses = classnames(
      componentStyles['_button'],
      styles['text-secondary'], {
        [componentStyles['--active']]: this.props.active,
        [componentStyles['--disabled']]: this.props.disabled
      }
    )

    return <li className={componentStyles['_item']}>
        { this.props.disabled ?
          <TooltipWrapper
            tooltipText={this.props.tooltipText}>
            <button
              type="button"
              className={mediaMenuItemClasses}
              data-bdd={this.props.dataBdd || 'talks-menu-menu-item'}
              ref={this.state.tooltipRef}
            >
              <div className={componentStyles['first-row']}>
                <Icon
                  name={this.props.icon}
                  className={componentStyles['button-icon']}
                  colour={this.props.active ? IconType.colour.brightTALKDark : undefined}
                />
                {this.notifications()}
              </div>

              <span className={componentStyles['_item-text']} >{this.props.text}</span>

            </button>
          </TooltipWrapper> :
          <button
            type="button"
            className={mediaMenuItemClasses}
            data-bdd={this.props.dataBdd || 'talks-menu-menu-item'}
            ref={this.state.tooltipRef}
            onClick={this.handleClick}
          >
            <div className={componentStyles['first-row']}>
              <Icon
                name={this.props.icon}
                className={componentStyles['button-icon']}
                colour={this.props.active ? IconType.colour.brightTALKDark : undefined}
              />
              {this.notifications()}
            </div>

            <span className={componentStyles['_item-text']} >{this.props.text}</span>

          </button>
        }
      </li>

  }

}

export default MediaMenuItem
